import { EXPRESS_API } from 'configs/api/expressApi';
import { convertToWebP, getWebpFilename } from 'lib/utils/convertToWebP';
import axios from 'axios';

export type UploadFileOptions = {
  webp?: boolean;
};

export const useUploadFile = () => {
  const uploadFile = async (
    file: File,
    onProgress?: (progress: number) => void,
    options?: UploadFileOptions
  ) => {
    onProgress?.(0);

    let payload: Blob | File = file;
    let filename = file.name;
    let filetype = file.type;

    if (options?.webp) {
      payload = await convertToWebP(file);
      filename = getWebpFilename(file.name);
      filetype = 'image/webp';
    }

    const data = {
      filename,
      filetype,
    };
    const response = await EXPRESS_API.post(
      `/aws/signedurl/user-uploaded-public-files`,
      data
    );

    const url = response.data.uploadUrl;

    await axios.put(url, payload, {
      headers: { 'content-type': filetype },
      onUploadProgress: progressEvent => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress?.(percentCompleted);
        }
      },
    });

    let downloadUrl = response.data.downloadUrl;
    onProgress?.(100);
    return downloadUrl;
  };

  return { uploadFile };
};
